import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import type { PreviewState, PreviewContext } from "./useTaskDetailActions";

export function PreviewDialog(props: {
  state: PreviewState;
  context: PreviewContext | null;
  onClose: () => void;
  onSelectVariation: (variationId: string) => void;
}) {
  const { context } = props;
  const currentSibling =
    context === null
      ? undefined
      : context.siblings.find((sibling) => sibling.id === context.currentVariationId);
  const currentIndex = currentSibling === undefined ? null : currentSibling.index;

  const title = `Превью вариации${currentIndex !== null ? ` #${currentIndex}` : ""}`;

  return (
    <Dialog open onClose={props.onClose} maxWidth="md" fullWidth PaperProps={{ sx: { height: "80vh" } }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ overflow: "auto" }}>
        {context && context.siblings.length > 1 && (
          <Box mb={2}>
            {context.siblings.map((seconds) => (
              <Button
                key={seconds.id}
                size="small"
                variant={seconds.id === context.currentVariationId ? "contained" : "outlined"}
                onClick={() => props.onSelectVariation(seconds.id)}
                disabled={seconds.id === context.currentVariationId}
                sx={{ mr: 0.5, minWidth: 0 }}
              >
                #{seconds.index}
              </Button>
            ))}
          </Box>
        )}
        {props.state.kind === "loading" && (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        )}
        {props.state.kind === "error" && (
          <Alert severity="error">{props.state.message}</Alert>
        )}
        {props.state.kind === "data" && (
          <>
            <Typography gutterBottom><strong>Анкор:</strong> {props.state.preview.anchorText}</Typography>
            <Box sx={{ border: 1, borderColor: "divider", p: 2, borderRadius: 1 }}>
              <Typography variant="h5" gutterBottom>{props.state.preview.title}</Typography>
              <Box dangerouslySetInnerHTML={{ __html: props.state.preview.htmlContent }} />
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  );
}
